import { render } from "./Register.vue?vue&type=template&id=bddf228e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=bddf228e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bddf228e"

export default script